import { useEffect, useState } from "react";

export const BrandMark = ({ brand, compact = false }) => {
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [brand.logo_url]);
  return (
    <div className="flex items-center gap-3 min-w-0" data-testid="partner-brand">
      {brand.logo_url && !broken ? (
        <img src={brand.logo_url} alt={brand.name} onError={() => setBroken(true)} className="h-9 max-w-[140px] object-contain" data-testid="partner-brand-logo" />
      ) : (
        <div className="h-9 w-9 shrink-0 grid place-items-center rounded-md font-display font-semibold text-white" style={{ background: brand.color }}>
          {brand.name.slice(0, 1).toUpperCase()}
        </div>
      )}
      <span className={`font-display text-lg font-semibold tracking-tight text-slate-100 truncate ${compact ? "hidden md:inline" : ""}`} data-testid="partner-brand-name">
        {brand.name}
      </span>
    </div>
  );
};
